// extracted by mini-css-extract-plugin
module.exports = {"Page":"_gOaTgdgaxkU5DM0J4Ka","Content":"BTUXY4iajHq9dehvR8KQ"};